//angular imports 
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

//local imports
import { RoomModel, RoomContentModel } from '@app/catalog';

@Component({
  selector: 'assign-room-content-to-room',
  standalone: false,
  templateUrl: './assign-room-content-to-room.component.html',
  styleUrl: './assign-room-content-to-room.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AssignRoomContentToRoomComponent {
  onCancelAssignment = output();

  roomContents = input.required<RoomContentModel[]>();
  assignedRoomContents = input.required<RoomContentModel[]>();
  rooms = input.required<RoomModel[]>();



  public applyAssignment() {

  }


  public cancelAssignment() {
    this.roomContents().forEach(item => item.isChecked.set(false));
    this.rooms().forEach(item => item.isChecked.set(false));
    this.onCancelAssignment.emit();
  }
}
